export default __webpack_public_path__ + "static/media/redbull.628de112.svg";